export default __webpack_public_path__ + "static/media/correct-tick.93af5fe0.png";